import { Component, ComponentFactoryResolver, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Models } from '@ibexfusion/models';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { PrivilegeService } from '@services/privileges/privilege.service';
import { FormDirective } from '../../../directives/form/form.directive';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { DefaultFormComponent } from '../../../components/default-form/default-form.component';
import { FormComponent } from '../../../components/default-form/form.component';

@Component({
    selector: 'app-privilege-edit',
    templateUrl: './privilege-edit.component.html',
    styleUrls: ['./privilege-edit.component.scss'],
    providers: [PrivilegeService],
    standalone: false
})
export class PrivilegeEditComponent implements OnInit {

  @ViewChild(FormDirective, { static: true }) formHost: FormDirective;

  pageActions: PageAction[];
  title = 'Privilege';
  isLoading = true;
  boundPrivilege: Models.Privilege;
  privilegeId: string;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private privilegeService: PrivilegeService,
    private activatedRoute: ActivatedRoute,
    private snackbar: SnackbarService
  ) {
  }

  ngOnInit() {
    if (this.activatedRoute.snapshot.params['id']) {
      this.privilegeId = this.activatedRoute.snapshot.params['id'];
      this.privilegeService.get(this.activatedRoute.snapshot.params['id']).then(result => {
        this.boundPrivilege = result;
        this.isLoading = false;
        this.loadForm();
      });
    } else {
      this.boundPrivilege = <Models.Privilege>Models.ModelFactory.createModelInstanceByName('Privilege');
      this.isLoading = false;
      this.loadForm();
    }
  }

  loadForm() {
    const formItem = DefaultFormComponent;

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(formItem);

    const viewContainerRef = this.formHost.viewContainerRef;
    viewContainerRef.clear();

    const componentRef = viewContainerRef.createComponent(componentFactory);
    (<FormComponent>componentRef.instance).entry = this.boundPrivilege;
  }

  onSave() {
    return this.boundPrivilege.validate(true).then(result => {
      if (result.success) {
        if (this.privilegeId) {
          this.privilegeService.update(this.privilegeId, this.boundPrivilege).then(organisationResult => {
            console.log(organisationResult);
          });
        } else {
          this.privilegeService.create(this.boundPrivilege).then(organisationResult => {
            console.log(organisationResult);
          });
        }
      } else {
        this.snackbar.open('Could not create the organisation, please fill the form correctly');
      }
    });
  }
}
